export const ENTITY_TYPE = {
  PARTNERSHIP: 'Partnership',
  PARTNERSHIP_TRUST: 'Partnership with a Trust',
  COMPANY: 'Company',
  COMPANY_TRUST: 'Company with a Trust',
  SOLE_TRADER: 'Sole Trader',
  SOLE_TRADER_TRUST: 'Sole Trader with a Trust',
};
